import axios from "axios";
import envConfig from "../../../env.config.js";

const instance = axios.create({
	baseURL: envConfig.apiNODE,
});

export default instance;
